import httpClient from "../utils/httpClient";

export const SendEmail = async (formData) => {
    const response = await httpClient.post('/SendEmail/contact', formData);
    return response.data;
};

export const FooterForm = async (formData) => {
    const response = await httpClient.post('/SendEmail/footer', formData, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    return response.data;
};

